import { useDictParseList } from '@/utils/useUtils'

const VEHICLE_OWNER = {
  LEGAL_PERSON: 1,
  NORMAL_PERSON: 2,
}

// 司机险枚举
const driverInsuranceList = {
  0: '不投保',
  1: '1万',
  2: '2万',
  3: '3万',
  4: '4万',
  5: '5万',
  6: '10万',
  7: '20万',
  8: '50万',
}

// 车损险枚举
const cwdInsuranceList = {
  0: '不投保',
  1: '投保',
}

// 第三者责任险枚举
const tripleInsuranceList = {
  0: '不投保',
  1: '10万',
  2: '15万',
  3: '20万',
  4: '30万',
  5: '50万',
  6: '100万',
  7: '150万',
  8: '200万',
  9: '250万',
  10: '300万',
  11: '350万',
  12: '400万',
  13: '450万',
  14: '500万',
  15: '1000万',
}

// 划痕险枚举
const scratchInsuranceList = {
  0: '不投保',
  1: '2千',
  2: '5千',
  3: '1万',
  4: '2万',
}

const verifyPhone = (_, value, callback) => {
  if (value === '') {
    return callback('请输入手机号')
  }
  if (!/^1[3456789]\d{9}$/.test(value)) {
    return callback('请输入正确的手机号')
  }
  return callback()
}


// 基本信息
const baseInfoList = [
  {
    el: 'input',
    itemConfig: {
      label: '联系电话',
      prop: 'telephone',
    },
    elConfig: {
      clearable: true,
    },
  },
  {
    el: 'input',
    itemConfig: {
      label: '备注',
      prop: 'remark',
    },
    elConfig: {
      clearable: true,
      maxlength: 500,
    },
  },
]

const carInfoList = [
  {
    el: 'select',
    itemConfig: {
      label: '车辆归属',
      prop: 'plateNoBelong',
    },
    elConfig: {
      clearable: true,
      options: {
        label: 'label',
        value: 'value',
        list: [
          { label: '法人', value: 1 },
          { label: '自然人', value: 2 },
        ],
      },
    },
  },
]

const personalInfoList = [
  {
    el: 'radio',
    itemConfig: {
      label: '投保人与被保人是否为同一人',
      prop: 'isSameInsurePerson',
    },
    elConfig: {
      options: {
        label: 'label',
        value: 'value',
        list: [
          { label: '是', value: true },
          { label: '否', value: false },
        ],
      },
    },
  },
  {
    el: 'radio',
    itemConfig: {
      label: '被投保人与车主是否为同一人',
      prop: 'isSameCarOwnerPerson',
    },
    elConfig: {
      options: {
        label: 'label',
        value: 'value',
        list: [
          { label: '是', value: true },
          { label: '否', value: false },
        ],
      },
    },
  },
]

const businessLicenseList = [
  {
    el: 'upload',
    itemConfig: {
      label: '营业执照',
      prop: 'businessLicense',
    },
    elConfig: {
      render: 'UploadCommon',
      listType: 'img',
      limit: 1,
      fileList: [],
      multiple: true,
      isAlone: false,
      commonUpload: true,
      group: 'assert',
      code: 'assert_business_license',
    },
  },
]

const getInsureApplicantList = (form) => {
  return [
    {
      el: 'input',
      itemConfig: {
        label: '投保人姓名',
        prop: 'insureApplicantName',
      },
      elConfig: {
        clearable: true,
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '投保人电话',
        prop: 'insureApplicantTelephone',
      },
      elConfig: {
        clearable: true,
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '投保人身份证正面',
        prop: 'insureApplicantIdcardFront',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'img',
        limit: 1,
        fileList: form.insureApplicantIdcardFront,
        isAlone: false,
        commonUpload: true,
        group: 'assert',
        code: 'assert_id_card_front_pic',
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '投保人身份证反面',
        prop: 'insureApplicantIdcardBack',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'img',
        limit: 1,
        fileList: form.insureApplicantIdcardBack,
        isAlone: false,
        commonUpload: true,
        group: 'assert',
        code: 'assert_id_card_back_pic',
      },
    },
  ]
}

const getInsureUseList = (form) => {
  return [
    {
      el: 'input',
      itemConfig: {
        label: '被保人姓名',
        prop: 'insureUseName',
      },
      elConfig: {
        clearable: true,
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '被保人电话',
        prop: 'insureUseTelephone',
      },
      elConfig: {
        clearable: true,
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '被保人身份证正面',
        prop: 'insureUseIdcardFront',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'img',
        limit: 1,
        fileList: form.insureUseIdcardFront,
        isAlone: false,
        commonUpload: true,
        group: 'assert',
        code: 'assert_id_card_front_pic',
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '被保人身份证反面',
        prop: 'insureUseIdcardBack',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'img',
        limit: 1,
        fileList: form.insureUseIdcardBack,
        isAlone: false,
        commonUpload: true,
        group: 'assert',
        code: 'assert_id_card_back_pic',
      },
    },
  ]
}

const getCarOwnerList = (form) => {
  return [
    {
      el: 'input',
      itemConfig: {
        label: '车主姓名',
        prop: 'driverName',
      },
      elConfig: {
        clearable: true,
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '车主电话',
        prop: 'driverTelephone',
      },
      elConfig: {
        clearable: true,
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '车主身份证正面',
        prop: 'driverIdcardFront',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'img',
        limit: 1,
        fileList: form.driverIdcardFront,
        isAlone: false,
        commonUpload: true,
        group: 'assert',
        code: 'assert_id_card_front_pic',
      },
    },
    {
      el: 'upload',
      itemConfig: {
        label: '车主身份证反面',
        prop: 'driverIdcardBack',
      },
      elConfig: {
        render: 'UploadCommon',
        listType: 'img',
        limit: 1,
        fileList: form.driverIdcardBack,
        isAlone: false,
        commonUpload: true,
        group: 'assert',
        code: 'assert_id_card_back_pic',
      },
    },
  ]
}


const insuranceTypeList = [
  {
    el: 'checkbox',
    itemConfig: {
      label: '选择投保险种',
      prop: 'insuranceType',
    },
    elConfig: {
      options: {
        label: 'label',
        value: 'value',
        list: [
          { label: '交强险', value: 'compulsoryInsurance' },
          { label: '商业险', value: 'commercialInsurance' },
        ],
      },
    },
  },
]

const insuranceList = [
  {
    el: 'select',
    itemConfig: {
      label: '司机险',
      prop: 'driverInsurance',
    },
    elConfig: {
      clearable: true,
      options: {
        label: 'label',
        value: 'value',
        list: useDictParseList(driverInsuranceList),
      },
    },
  },
  {
    el: 'select',
    itemConfig: {
      label: '车损险',
      prop: 'cdw',
    },
    elConfig: {
      clearable: true,
      options: {
        label: 'label',
        value: 'value',
        list: useDictParseList(cwdInsuranceList),
      },
    },
  },
  {
    el: 'select',
    itemConfig: {
      label: '第三者责任险',
      prop: 'tripleInsurance',
    },
    elConfig: {
      clearable: true,
      options: {
        label: 'label',
        value: 'value',
        list: useDictParseList(tripleInsuranceList),
      },
    },
  },
  {
    el: 'select',
    itemConfig: {
      label: '划痕险',
      prop: 'scratchInsurance',
    },
    elConfig: {
      clearable: true,
      options: {
        label: 'label',
        value: 'value',
        list: useDictParseList(scratchInsuranceList),
      },
    },
  },
]

const rules = {
  adcode: [
    { required: true, message: '请输入报价城市', trigger: 'change' },
  ],
  brandId: [
    { required: true, message: '请选择品牌', trigger: 'change' },
  ],
  modelId: [
    { required: true, message: '请选择车型', trigger: 'change' },
  ],
  telephone: [
    { required: true,
      trigger: 'change',
      validator: verifyPhone,
    },
  ],
  plateNoBelong: [
    { required: true, message: '请选择车辆归属', trigger: 'change' },
  ],
  isSameInsurePerson: [
    { required: true, message: '请选择投保人与被保人是否为同一人', trigger: 'change' },
  ],
  isSameCarOwnerPerson: [
    { required: true, message: '请选择车主与被保人是否为同一人', trigger: 'change' },
  ],
  businessLicense: [
    { required: true, message: '请上传营业执照', trigger: 'change' },
  ],
  insureApplicantName: [
    { required: true, message: '请输入投保人姓名', trigger: 'change' },
  ],
  insureApplicantTelephone: [
    { required: true,
      trigger: 'change',
      validator: verifyPhone,
    },
  ],
  insureApplicantIdcardFront: [
    { required: true,
      message: '请上传投保人身份证正面',
      trigger: 'change',
    },
  ],
  insureApplicantIdcardBack: [
    { required: true, message: '请上传投保人身份证反面', trigger: 'blur' },
  ],
  insureUseName: [
    { required: true, message: '请输入被保人姓名', trigger: 'change' },
  ],
  insureUseTelephone: [
    { required: true,
      trigger: 'change',
      validator: verifyPhone,
    },
  ],
  insureUseIdcardFront: [
    { required: true, message: '请上传被保人身份证正面', trigger: 'change' },
  ],
  insureUseIdcardBack: [
    { required: true, message: '请上传被保人身份证反面', trigger: 'change' },
  ],
  driverName: [
    { required: true, message: '请输入车主姓名', trigger: 'change' },
  ],
  driverTelephone: [
    { required: true, trigger: 'change', validator: verifyPhone },
  ],
  driverIdcardFront: [
    { required: true, message: '请上传车主身份证正面', trigger: 'change' },
  ],
  driverIdcardBack: [
    { required: true, message: '请上传车主身份证反面', trigger: 'change' },
  ],
  driverInsurance: [
    { required: true, message: '请选择司机险保额', trigger: 'change' },
  ],
  insuranceType: [
    { required: true, message: '请选择投保险种', trigger: 'change' },
  ],
  cdw: [
    { required: true, message: '请选择车损险', trigger: 'change' },
  ],
  tripleInsurance: [
    { required: true, message: '请选择第三者责任险', trigger: 'change' },
  ],
  scratchInsurance: [
    { required: true, message: '请选择划痕险', trigger: 'change' },
  ],
}

export default {
  baseInfoList,
  carInfoList,
  personalInfoList,
  businessLicenseList,
  getInsureApplicantList,
  getInsureUseList,
  getCarOwnerList,
  insuranceTypeList,
  insuranceList,
  rules,
  VEHICLE_OWNER,
}
